<div class="am-snackbar">
	<span>{{ data.message }}</span>

	<div *ngIf="hasAction">
		<button mat-stroked-button (click)="action()">{{ data.action }}</button>
	</div>
</div>
